import styled, { css } from 'styled-components';
import { layout, media, colors } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';
import TooltipComponent from '@prisjakt/ui-tooltip-new';

type DisplayOptionsDividerProps = {
  hidden?: boolean;
};

export const Tooltip = styled(TooltipComponent)``;

export const DisplayOptionsDivider = styled.span<DisplayOptionsDividerProps>`
  display: inline-block;
  width: 1px;
  height: 24px;
  background-color: ${({ theme }) => theme.lines.secondary};
  transition: opacity 0.3s ease-out;
  opacity: ${({ hidden }) => (hidden ? 0 : 1)};
`;

export const DisplayOptions = styled.div`
  display: flex;
  align-content: start;
  align-items: center;
`;
export const Wrapper = styled.main`
  margin-bottom: ${layout.spacing.xSmall};
  padding: 0 ${layout.spacing.xSmall};
`;

export const ProductsHeader = styled.div`
  .pj-ui-panel-header--child-container {
    flex: 1;
    justify-content: space-between;
    margin-top: 0;
    align-items: center;
  }
`;

export const ProductGrid = styled.ul`
  @supports (grid-template-columns: repeat(auto-fill, minmax(auto, 50%))) {
    display: grid;
    flex: 1 0 auto;
    grid-gap: ${layout.spacing};
    grid-template-columns: repeat(auto-fill, minmax(auto, 50%));
    list-style: none;

    ${media.mediumOnly`
    grid-template-columns: repeat(auto-fill, minmax(auto, 33%));
  `}

    ${media.largeUp`
    grid-template-columns: repeat(auto-fill, minmax(auto, 25%));
  `}
  }

  /* Fallback to flex if grid-template-columns is not supported */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const ProductGridItem = styled.li``;

export const ProductList = styled.ul`
  display: flex;
  list-style: none;
`;

export const ProductListItem = styled.li`
  width: 100%;
`;

export const Advert = styled.li<{ row: number }>`
  grid-row: ${p => p.row || '0'};
  grid-column: 1 / -1;
`;

export const SidebarFilterButton = styled(Button)`
  ${media.mediumDown`
    display: none;
  `}
`;

export const SortOptions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const SortOptionsTitle = styled.span`
  font-weight: 600;
  color: ${p => p.theme.text.quaternary};
  margin-left: ${layout.spacing.xSmall};

  ${media.smallOnly`
    display: none;
  `};
`;

export const SortOptionsButton = styled(Button)`
  padding: 0;
  margin-left: ${layout.spacing.xSmall};

  ${media.mediumDown`
    margin-right: ${layout.spacing.xSmall};
  `};
`;

export const ProductCount = styled.div`
  text-align: center;
  margin-top: ${layout.spacing.xSmall};
`;

export const Notice = styled.p`
  font: inherit;
  margin: ${layout.spacing.large} auto;
  max-width: 40em;
`;

export const LayoutPicker = styled.div`
  align-self: stretch;
  display: flex;
  justify-content: center;
`;

type LayoutButtonProps = {
  active: boolean;
};

export const LayoutButton = styled.button<LayoutButtonProps>`
  display: flex;
  align-items: center;
  outline: none;
  cursor: pointer;
  padding: 0 4px;
  position: relative;
  color: ${({ active }: LayoutButtonProps) =>
    active ? colors.darkBlue1 : colors.lightGray1};
  &:hover {
    color: ${p => p.theme.icons.callToActionHover};
  }
`;

export const LayoutButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0 8px;
`;

type SearchInputProps = {
  expanded?: boolean;
  inputWidth?: string;
};

export const SearchInput = styled.div<SearchInputProps>`
  position: relative;
  min-width: 40px;
  display: flex;
  align-content: start;
  align-items: center;
  flex: 1;
`;
export const SearchTextWrapper = styled.div<SearchInputProps>`
  transition: ${({ expanded }) =>
    expanded
      ? 'opacity 0.1s ease-out 0.1s, width 0.25s ease-out'
      : 'opacity 0.1s ease-out, width 0.25s ease-out'};
  width: ${({ expanded, inputWidth }) =>
    expanded ? inputWidth || '330px' : '40px'};
  opacity: ${({ expanded }) => (expanded ? '1' : '0')};
`;

type SearchInputIconProps = {
  positionAbsolute?: boolean;
};

export const SearchInputIcon = styled.button<SearchInputIconProps>`
  ${({ positionAbsolute }) =>
    positionAbsolute
      ? css`
          position: absolute;
          right: 0;
        `
      : ''}
  height: 100%;
  min-height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    color: ${p => p.theme.icons.callToActionHover};
  }
`;

export const PanelHeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const PanelHeaderRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
